import { CellProps } from 'react-table';

import { TrackableItem } from 'types/trackables';

import { useModal } from 'hooks/useModal';
import { useAppRedirect } from 'hooks/useAppRedirect';
import { useDeleteTrackableItems } from '../../hooks/useDeleteTrackableItems';

import {
  ContextMenu,
  ContextMenuAction,
} from 'components/ContextMenu/ContextMenu';
import { IconButton } from 'components/IconButton/IconButtonDeprecated';

export type TrackableItemsTableActionsCellProps = CellProps<TrackableItem> & {
  trackableListId: string;
};

export function TrackableItemsTableActionsCell({
  row,
  trackableListId,
}: TrackableItemsTableActionsCellProps) {
  const trackableItem = row.original;
  const redirect = useAppRedirect();

  const { open } = useModal();
  const { mutateAsync: deleteTrackableItems } = useDeleteTrackableItems();

  function handleEditClick() {
    redirect(`/deploy/trackables/${trackableListId}/items/${trackableItem.id}`);
  }

  function handleDeleteClick() {
    open('confirm-delete', {
      title: `Are you sure you want to delete ${trackableItem.name}?`,
      onConfirm: () => deleteTrackableItems({
        trackable_list_id: trackableListId,
        trackable_item_ids: [trackableItem.id],
      }),
    });
  }

  return (
    <ContextMenu
      trigger={
        <IconButton
          icon="more-vertical"
          label="Reveal more actions"
          variant="ghost"
        />
      }
    >
      <ContextMenuAction onClick={handleEditClick} icon="edit">
        Edit
      </ContextMenuAction>
      <ContextMenuAction onClick={handleDeleteClick} icon="delete">
        Delete
      </ContextMenuAction>
    </ContextMenu>
  );
}